import { render } from "./ReihenhausStep2.vue?vue&type=template&id=f71fb494&scoped=true"
import script from "./ReihenhausStep2.vue?vue&type=script&lang=js"
export * from "./ReihenhausStep2.vue?vue&type=script&lang=js"

import "./ReihenhausStep2.vue?vue&type=style&index=0&id=f71fb494&scoped=true&lang=css"

import exportComponent from "/Users/a98ca8a/projects/immo-calculator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f71fb494"]])

export default __exports__